import Query from "../utils/Query";

export default class FormService {

	static send(type, data) {
		return Query.post('/items/form', {
			type,
			content: data,
		});
	}
}
